import FormTextArea from "component/form/form_textarea";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultSupporterInfoSelector } from "store/user/(default)/supporter/default_supporter.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SupporterNote = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const supporterInfo = useSelector(defaultSupporterInfoSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!supporterInfo) return null;
  return (
    <FormTextArea
      name="note"
      rules={[{ required: true, message: "Điền thông tin đầy đủ" }]}
      placeholder="Ghi chú thêm: Thuộc chi nhánh Dịch Vụ Chuyển Âm nào ?"
      rows={4}
    />
  );
};
export default SupporterNote;
